<template>
  <!-- eslint-disable vue/valid-v-slot -->
  <v-card>

    <v-dialog v-model="dgKullaniciExtra" width="800">
      <v-card>
        <v-toolbar dark color="primary">

          <v-toolbar-title>Veritabanlarından Ek Çekilen Veriler</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dgKullaniciExtra = false">
              Çıkış
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <!-- <v-card-title class="text-h5 grey lighten-2">
        Form Yetkilendirme
        </v-card-title> -->

        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                Öğrenci Veritabanından Alınabilen Ek Veriler
                <v-form>
                  <v-data-table height="500" v-model="selectedExtFields.ogrenci" :items-per-page="-1"
                    hide-default-footer :headers="[{ text: 'Alan Adı', value: 'name' },]" :items="extFields.ogrenci"
                    item-key="id" show-select class="elevation-1">

                  </v-data-table>
                  <!-- <v-checkbox
        v-for="item in extFields.ogrenci"
        :key="item.id" return-object
        :label="item.name"
        :value="item.id"
        v-model="selectedExtFields.ogrenci"
        hide-details
        dense
      ></v-checkbox> -->
                </v-form>

                <!-- <div class="mt-4">
      <strong>Seçilen Alanlar:</strong>
      <pre>{{ selectedExtFields }}</pre>
    </div> -->
              </v-col>
              <v-col>
                Personel Veritabanından Alınabilen Ek Veriler
                <v-data-table v-model="selectedExtFields.personel" :headers="[{ text: 'Alan Adı', value: 'name' },]"
                  :items-per-page="-1" hide-default-footer :items="extFields.personel" height="500" item-key="id"
                  show-select class="elevation-1">

                </v-data-table>
                <!-- 
    <div class="mt-4">
      <strong>Seçilen Alanlar:</strong>
      <pre>{{ selectedExtFields }}</pre>
    </div> -->
              </v-col>
            </v-row>

          </v-container>

        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dgYoneticiForm" width="500">


      <v-card>
        <v-toolbar dark color="primary">

          <v-toolbar-title> Form Yetkilendirme</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dgYoneticiForm = false">
              Çıkış
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <!-- <v-card-title class="text-h5 grey lighten-2">
        Form Yetkilendirme
        </v-card-title> -->

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="tc" append-outer-icon="mdi-account-search" filled clear-icon="mdi-close-circle"
                  clearable label="TC Giriniz" type="text" @click:append-outer="getPersonel"></v-text-field>

                <v-subheader>SORGU SONUCU </v-subheader>
                <v-list-item v-if="selectedYonetici">
                  <v-list-item-content>
                    <v-list-item-title>{{ selectedYonetici.tc }}</v-list-item-title>
                    <v-list-item-subtitle>{{ selectedYonetici.ad }} {{ selectedYonetici.soyad }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="yoneticiEkle">
                      <v-icon color="grey lighten-1">mdi-account-plus</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <p class="text-color-secondary" v-else>Lütfen geçerli bir TC ile arama yapınız.</p>
              </v-col>
            </v-row>
          </v-container>
          <v-list dense>
            <v-subheader>DİĞER YETKİLİ YÖNETİCİLER </v-subheader>
            <v-list-item-group color="primary">
              <v-list-item v-for="(item, i) in lsYoneticis" :key="i">
                <!-- <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon> -->
                <v-list-item-content>
                  <v-list-item-title>{{ item.tc }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.ad + " " + item.soyad }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="evDeleteYonetici(item)">
                    <v-icon color="grey lighten-1">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>

              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>


      </v-card>
    </v-dialog>



    <v-data-table :headers="headers" :items="values" :items-per-page="10" class="elevation-1" show-expand
      :single-expand="true" item-key="formId">

      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length">

          <v-alert v-if="!item.loginGiris" type="info" dense text>
            {{ mainUrl }}/formview/{{ item.formId }}
          </v-alert>
          <v-alert v-else type="info" dense text>
            {{ mainUrl }}/login/{{ item.formId }}
          </v-alert>
        </td>
      </template>


      <template v-slot:top>
        <v-toolbar dark color="primary" flat>
          <v-toolbar-title>Formlar</v-toolbar-title>
          <v-dialog v-model="dialog" max-width="1200px">

            <v-card>
              <v-toolbar dark color="primary" flat>
                <v-toolbar-title> <span class="text-h5">{{ formTitle }}</span></v-toolbar-title>
                <template v-slot:extension>

                  <v-tabs v-model="tab" fixed-tabs>
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#one" class="">
                      <v-icon>mdi-receipt-text-edit-outline</v-icon>
                      Form Bilgileri
                    </v-tab>

                    <v-tab href="#two">
                      <v-icon>mdi-form-dropdown</v-icon> Formu Kimler Dolduracak
                    </v-tab>

                    <v-tab href="#three">
                      <v-icon>mdi-account-details-outline</v-icon> Kim Kimleri Denetleyecek
                    </v-tab>
                  </v-tabs>
                </template>
              </v-toolbar>
              <v-tabs-items v-model="tab">
                <v-tab-item value="one">
                  <v-card flat>
                    <v-card-text>
                      <v-form ref="frmForm">
                        <v-container>
                          <v-row>
                            <v-col cols="6" sm="6" md="6">
                              <v-text-field v-model="editedItem.name" label="Form Adı"
                                :rules="[required]"></v-text-field>
                            </v-col>

                            <v-col cols="3" sm="3" md="3">

                              <v-select v-model="editedItem.formType" :items="formTypes" item-text="name"
                                :rules="[requiredEmpty]" item-value="id" label="Form Türü" :value="null"></v-select>
                            </v-col>
                            <v-col cols="3" sm="3" md="3">
                              <v-text-field v-model="editedItem.groupName" label="Form Grup Adı"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="4" md="4">
                              <VDate label="Başlama Tarihi" v-model="editedItem.baslamaTarihi" :rules="[required]">
                              </VDate>

                            </v-col>
                            <v-col cols="6" sm="2" md="2">
                              <v-select v-model="editedItem.baslamaTime" :items="timeOptions" :rules="[required]"
                                label="Zaman Seçiniz"></v-select>

                            </v-col>
                            <v-col cols="6" sm="4" md="4">
                              <VDate label="Bitiş Tarihi" :rules="[required]" v-model="editedItem.bitisTarihi">
                              </VDate>
                            </v-col>
                            <v-col cols="6" sm="2" md="2">
                              <v-select v-model="editedItem.bitisTime" :items="timeOptions" :rules="[required]"
                                label="Zaman Seçiniz"></v-select>


                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                              <VDate label="Değerlendirme Son Tarihi" :rules="[required]"
                                v-model="editedItem.degerlendirmeSonTarihi">
                              </VDate>
                            </v-col>
                          
                            <v-col cols="3" sm="3" md="3">
                              <v-checkbox v-model="editedItem.loginGiris"
                                label="Sisteme giriş yapılarak form doldurulsun"></v-checkbox>
                            </v-col>
                             <v-col cols="3" sm="3" md="3"> <v-text-field type="number"
                                v-model="editedItem.maxFormBasvuruLimiti" label="Form Başvuru Max Limiti" 
                                @input="val => editedItem.maxFormBasvuruLimiti = val === '' ? null : Number(val)"
                                persistent-hint>
                                <template v-slot:prepend>
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>

                                    </template>
                                    <span>Formunuza limitli başvuru isteğiniz içindir.ÖRN:50 değeri girilirse formunuz 50 Kayıt
                                      alır. 51.Kişi
                                      başvuru yapamayacaktır.
                                      <br>Limit koymak istemez iseniz boş bırakınız.
                                      <br>Bu özellik forma başvuru yapan tüm başvuru sayısını kontrol etmektedir.
                                     
                               
                                    </span>
                                  </v-tooltip>
                                </template>



                              </v-text-field> </v-col>
                            <v-col cols="4" sm="4" md="4" v-if="editedItem.loginGiris">
                              <v-checkbox v-model="editedItem.onaylama"
                                label="Formu onaylama sistemine tabii tut"></v-checkbox>
                            </v-col>
                            <!-- <v-col cols="6" sm="6" md="4" v-if="editedItem.loginGiris">
                              <v-checkbox v-model="editedItem.sadeceBirDefaBasvur"
                                label="Kulllanıcı bir defa başvursun"></v-checkbox>
                            </v-col> -->
                              <v-col cols="3" sm="3" md="3" v-if="editedItem.onaylama">

                              <v-select label="Limit için onay durumları" v-model="editedItem.limitBasvuruDurumListesi"
                                :items="onayDurums" item-text="named" item-value="id" multiple persistent-hint>

                              </v-select>
                            </v-col>
                            <v-col cols="5" sm="5" md="5"> <v-text-field type="number"
                                v-model="editedItem.maxBasvuruLimiti" label="Başvuru Max Limiti" hint=""
                                @input="val => editedItem.maxBasvuruLimiti = val === '' ? null : Number(val)"
                                persistent-hint>
                                <template v-slot:prepend>
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>

                                    </template>
                                    <span>Formunuza kullanıcı bazlı limitli başvuru isteğiniz içindir.ÖRN:50 değeri girilirse bir kullanıcı için 50 Kayıt
                                      alınır.O kullanıcı 51. başvuruyu yapamayacaktır.
                                      <br>Limit koymak istemez iseniz boş bırakınız.
                                      <br>Formunuz onaylama sistemini kullanıyor ise bu limit ayarını başvuruların onay durumlarına göre filtreleyebilirsiniz.
                                      <br>ÖRN:"Onaylandı"  ve "Onaya Sunuldu" işaretlenir, limite 50 girilirse forma başvuruların onaylanan ve onaya sunulan toplamı 50 olduktan sonra forma başvuru almaz
                                      <br>
                                    </span>
                                  </v-tooltip>
                                </template>



                              </v-text-field> </v-col>
                            <v-col cols="12" v-if="editedItem.loginGiris">


                              <table class="w-100">
                                <tr>
                                  <th></th>
                                  <th>Öğrenci Bilgi Sisteminden Çekilecek Alanlar</th>
                                  <th>Personel Bilgi Sisteminden Çekilecek Alanlar</th>
                                </tr>
                                <tr>
                                  <td><v-btn @click="dgKullaniciExtra = true">Ekle</v-btn></td>
                                  <td>
                                    <v-chip v-for="itemOgrenci in selectedExtFields.ogrenci" :key="itemOgrenci.id"
                                      class="ma-2" color="primary">
                                      {{ itemOgrenci.name }}
                                    </v-chip>
                                  </td>
                                  <td>
                                    <v-chip v-for="itemPersonel in selectedExtFields.personel" :key="itemPersonel.id"
                                      class="ma-2" color="green">
                                      {{ itemPersonel.name }}
                                    </v-chip>
                                  </td>
                                </tr>
                              </table>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">

                              <v-select v-model="editedItem.durumId" :items="durums" item-text="name"
                                :rules="[required]" item-value="id" label="Durum"></v-select>
                            </v-col>

                          </v-row>
                        </v-container>
                      </v-form>

                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="two">
                  <v-card flat>
                    <v-card-text>

                      <!-- <dinamik-filtreleme :form-id="editedItem.formId"></dinamik-filtreleme> -->
                      <!-- <Filtreleme v-model="filterUser"></Filtreleme> -->
                      <!-- <filter-check-select></filter-check-select>  -->

                      <dinamik-filter :fields="filterItems" :value="visibleIf"></dinamik-filter>
                      <!-- <BirimComboSelect></BirimComboSelect> 
<UnvanComboSelect></UnvanComboSelect> -->
                      <!-- <v-row>
                      <v-col cols="12">
                        <v-text-field label="Bireysel Filtreleme"
                          hint="Öğrenci için öğrenci numarası,personel için eposta adresi ÖRN:2025010512,ahmetyayla@amasya.edu.tr"
                          v-model="filterUser.custom"></v-text-field>
                      </v-col>
                      <v-divider></v-divider>
                      <v-col cols="3" sm="3" md="3">
                        Öğrenci Birimleri <v-icon large color="blue darken-2" dark
                          @click="birimChange(1)">mdi-file-edit</v-icon>
                        <ul style="max-height: 250px;overflow-y: auto;">
                          <li v-for="ogrenciId in filterUser.ogrenciProgramIds" :key="ogrenciId"></li>
                        </ul>



                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col cols="3" sm="3" md="3">
                        Akademi Birimleri <v-icon large color="blue darken-2" dark
                          @click="birimChange(1)">mdi-file-edit</v-icon>
                        <ul style="max-height: 250px;overflow-y: auto;">
                          <li v-for="item in filterUser.pbsAkademisyenBirimIds" :key="item.id">{{ item.name }}</li>
                        </ul>
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col cols="3" sm="3" md="3">
                        İdari Birimler <v-icon large color="blue darken-2" dark
                          @click="birimChange(2)">mdi-file-edit</v-icon>
                        <ul style="max-height: 250px;overflow-y: auto;">
                          <li v-for="item in filterUser.pbsIdariBirimIds" :key="item">{{ item.name }}</li>
                        </ul>
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col cols="3" sm="3" md="3">
                        İdari Birimler <v-icon large color="blue darken-2" dark
                          @click="birimChange(3)">mdi-file-edit</v-icon>
                        <ul style="max-height: 250px;overflow-y: auto;">
                          <li v-for="item in filterUser.pbsDigerBirimIds" :key="item">{{ item.name }}</li>
                        </ul>
                      </v-col>


                    </v-row> -->
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="three">
                  <v-card flat>
                    <v-card-text>
                      <v-row>
                        <v-col cols="10">
                          <!-- {{ selectedFilter }}
                      <Filtreleme v-model="selectedFilter"></Filtreleme> -->

                          <v-dialog v-model="dgKimleriDegerlendirecek" width="1200">


                            <v-card>
                              <v-card-title class="text-h5 grey lighten-2">
                                Yetki Seçimi
                              </v-card-title>

                              <v-card-text>

                                <dinamik-filter :fields="filterItems"
                                  :value="selectedPersonelItem.filter"></dinamik-filter>
                                <!-- <Filtreleme v-if="selectedPersonelItem" v-model="selectedPersonelItem.filter">
                                </Filtreleme> -->
                              </v-card-text>

                              <v-divider></v-divider>

                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="btnKimleriDegerlendirecekAdd">
                                  Ekle
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                          <v-dialog v-model="dgKullaniciKimlerDegerlendirecek" width="1200">


                            <v-card>
                              <v-card-title class="text-h5 grey lighten-2">
                                Yetki Seçimi
                              </v-card-title>

                              <v-card-text>
                                <!-- {{ selectedPersonelItem }} -->
                                <Filtreleme v-if="selectedPersonelItem" v-model="selectedPersonelItem.filter">
                                </Filtreleme>
                              </v-card-text>

                              <v-divider></v-divider>

                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="btnKimlerDegerlendirecekAdd">
                                  Ekle
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                          <!-- <v-autocomplete v-model="selectedPersonel" filled :items="personels" return-object
                            item-text="name" label="Personel Listesi" @change="cbPersonelChange"></v-autocomplete> -->
                          <user-select @selectedChange="btnSelectedPersonelAdd"> </user-select>
                        </v-col>
                        <!-- <v-col cols="2">
                          <v-btn color="warning" @click="btnSelectedPersonelAdd">
                            <v-icon>mdi-account-plus</v-icon> Ekle
                          </v-btn>
                        </v-col> -->
                      </v-row>
                      <v-row>
                        <v-col>





                          <ul>
                            <li v-for="item in selectedKullanicis" :key="item.id">

                              <v-list-item>
                                <v-list-item-action>

                                  <v-btn icon @click="selectedKullanicisDelete(item)">
                                    <v-icon color="red lighten-1">
                                      mdi-trash-can-outline
                                    </v-icon>
                                  </v-btn>



                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.name }}</v-list-item-title>

                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-btn color="warning" @click="btnKimlerDegerlendirecekDgShow(item)">
                                    Yetki
                                  </v-btn>
                                </v-list-item-action>
                              </v-list-item>



                              <v-divider></v-divider>
                              <!-- <v-row>


                                <v-col cols="3" sm="3" md="3">
                                  Öğrenci Birimleri
                                  <ul style="max-height: 250px;overflow-y: auto;">
                                    <li v-for="ogrenciProgram in item.filter.ogrenciProgramIds"
                                      :key="ogrenciProgram.id">
                                      {{
                                        ogrenciProgram.name }}</li>
                                  </ul>



                                </v-col>
                                <v-divider vertical></v-divider>
                                <v-col cols="3" sm="3" md="3">
                                  Akademi Birimleri
                                  <ul style="max-height: 250px;overflow-y: auto;">
                                    <li v-for="itemAkademi in item.filter.pbsAkademisyenBirimIds" :key="itemAkademi.id">
                                      {{
                                        itemAkademi.name }}</li>
                                  </ul>
                                </v-col>
                                <v-divider vertical></v-divider>
                                <v-col cols="3" sm="3" md="3">
                                  İdari Birimler
                                  <ul style="max-height: 250px;overflow-y: auto;">
                                    <li v-for="itemIdari in item.filter.pbsIdariBirimIds" :key="itemIdari.id">{{
                                      itemIdari.name }}
                                    </li>
                                  </ul>
                                </v-col>
                                <v-divider vertical></v-divider>
                                <v-col cols="3" sm="3" md="3">
                                  Diğer Birimler
                                  <ul style="max-height: 250px;overflow-y: auto;">
                                    <li v-for="itemDiger in item.filter.pbsDigerBirimIds" :key="itemDiger.id">{{
                                      itemDiger.name }}
                                    </li>
                                  </ul>
                                </v-col>


                              </v-row> -->


                            </li>
                          </ul>
                        </v-col>
                      </v-row>


                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
              <v-card-title>

              </v-card-title>

              <v-card-text>

                <!-- <v-dialog scrollable v-model="dgBirim" width="700">


                <v-card>
                  <v-card-title class="text-h5 grey lighten-2">
                    Birim Ağaçı
                  </v-card-title>

                  <v-card-text>
                    <v-treeview return-object v-model="selectedBirimIds" selectable :items="items"></v-treeview>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="btnBirimAdd()">
                      Düzenle
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog> -->





              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="blue darken-1" text @click="btnFormSave">
                Cancel
              </v-btn> -->
                <v-btn large color="primary" @click="btnFormSave">
                  <v-icon dark>
                    mdi-content-save
                  </v-icon>
                  Kaydet
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        </v-toolbar>
      </template>


      <template v-slot:item.new="{ index }">
        <span class="mx-2"> {{ index + 1 }}</span>

      </template>
      <template v-slot:header.new="{ header }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="addShowItem(item)" v-bind="attrs" v-on="on">
              <v-icon large color="primary" class="mx-2">
                mdi-plus
              </v-icon></v-btn>


          </template>
          <span>{{ header.text }}</span>
        </v-tooltip>

      </template>
      <template v-slot:item.actions="{ item, index }">


        <v-menu bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="editItem(item)">
              <v-list-item-icon>
                <v-icon large>mdi-database-arrow-left-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Ön İzleme</v-list-item-title>
            </v-list-item>

            <v-list-item @click="formTasarimGonder(item)">
              <v-list-item-icon>
                <v-icon large>mdi-abacus</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Form Tasarımı</v-list-item-title>
            </v-list-item>
            <v-list-item @click="formBasvurulariGoster(item)">
              <v-list-item-icon>
                <v-icon large>mdi-database-eye</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Form Başvuruları Göster</v-list-item-title>
            </v-list-item>
            <v-list-item @click="formKopyala(item, index)">
              <v-list-item-icon>
                <v-icon large>mdi-content-copy</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Form Kopyala</v-list-item-title>
            </v-list-item>
            <v-list-item @click="editShowItem(item)">
              <v-list-item-icon>
                <v-icon large>mdi-pencil</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Güncelle</v-list-item-title>
            </v-list-item>
            <v-list-item @click="deleteForm(item)">
              <v-list-item-icon>
                <v-icon large>mdi-delete</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Sil</v-list-item-title>
            </v-list-item>
            <v-list-item @click="yetkilendirme(item)">
              <v-list-item-icon>
                <v-icon large>mdi-table-account</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Yetkilendirme</v-list-item-title>
            </v-list-item>
            <v-list-item @click="btnAnketRaporuClick(item)">
              <v-list-item-icon>
                <v-icon large>mdi-poll</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Anket Raporu</v-list-item-title>
            </v-list-item>

          </v-list>
        </v-menu>


        <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon large @click="editItem(item)" class="mx-2" v-bind="attrs" v-on="on">
            mdi-database-arrow-left-outline
          </v-icon>
        </template>
        <span>Form Veri Girişi</span>
      </v-tooltip>




      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon large @click="formTasarimGonder(item)" v-bind="attrs" class="mx-2" v-on="on">
            mdi-abacus
          </v-icon>
        </template>
        <span>Form Tasarımı</span>
      </v-tooltip>


      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon large @click="formBasvurulariGoster(item)" v-bind="attrs" class="mx-2" v-on="on">
            mdi-database-eye
          </v-icon>
        </template>
        <span>Form Başvuruları Göster</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon large @click="editShowItem(item)" v-bind="attrs" class="mx-2" v-on="on">
            mdi-pencil
          </v-icon>
        </template>
        <span>Güncelle</span>
      </v-tooltip> -->
      </template>

    </v-data-table>
  </v-card>

</template>
<script>
//import router from '@/router';
import Vue from 'vue';

import router from '@/router/index';
import FormService from '@/services/FormService';
import VDate from '@/components/CustomDatePicker.vue';
import DurumService from '@/services/DurumService';
import UserSelect from '@/components/UserSelect.vue';
import FilterUserService from '@/services/FilterUserService';
import Filtreleme from '@/components/Filtreleme.vue';
// import DinamikFiltreleme from '../components/DinamikFiltreleme.vue';
import DinamikFilter from '@/components/DinamikFilter.vue';
import OnayDurumService from '@/services/OnayDurumService';

// import BirimComboSelect from '@/components/BirimComboSelect.vue';
// import UnvanComboSelect from '@/components/UnvanComboSelect.vue';
//import FilterCheckSelect from '../components/FilterCheckSelect.vue';


export default {
  components: {
    VDate, Filtreleme,
    DinamikFilter,
    UserSelect,
    // BirimComboSelect,
    // UnvanComboSelect,
    //FilterCheckSelect

    // DinamikFiltreleme
  },
  name: "FormListesi",
  computed: {


    formTitle() {
      return this.editedIndex === -1 ? 'Yeni Form Tanımlama' : 'Form Güncelle'
    },
  },
  data() {
    return {
      formTypes: [{ id: 1, name: "Anket Formu" }, { id: 0, name: "Uygulama Formu" }],
      returnKuralOlusum: {},
      visibleIf: { logic: "AND", conditions: [] },
      visibleIfHam: { logic: "AND", conditions: [] },
      filterItems: [],
      dgKullaniciExtra: false,
      extFields: {},
      selectedExtFields: { ogrenci: [], personel: [] },
      tc: "",
      selectedYonetici: null,
      timeOptions: this.generateTimeOptions(),
      lsYoneticis: [],
      dgYoneticiForm: false,
      mainUrl: process.env.VUE_APP_URL,
      dgKullaniciKimlerDegerlendirecek: false,
      dgKimleriDegerlendirecek: false,
      selectedFilter: null,
      selectedKullanicis: [],
      selectedPersonel: null,
      selectedPersonelItem: { filter: { logic: "AND", conditions: [] } },
      tab: null,
      dgBirim: false,
      selectedBirimIds: [],
      selectedBirimTurId: 0,
      required: value => !!value || 'Gerekli.',
      requiredEmpty: value => value != null || 'Gerekli.',
      editedItem: {
        formId: null,
        name: "",
        groupName: "",
        formType: "",
        // baslamaTarihi: (new Date()).toISOString().substr(0, 10),
        // bitisTarihi: new Date().toISOString().substr(0, 10),
        detayKullaniciBilgileri: { ogrenci: [], personel: [] },
        baslamaTarihi: "",
        baslamaTime: "",
        bitisTarihi: "",
        bitisTime: "",
        degerlendirmeSonTarihi: "",
        loginGiris: false,
        maxFormBasvuruLimiti:null,
        maxBasvuruLimiti: null,
        LimitBasvuruDurumListesi: [],
        onaylama: false,
        sadeceBirDefaBasvur: false,
        filtrelemeJson: "",
        durumId: 0
      },
      editedIndex: 0,
      durums: [],
      dialog: false,
      form: null,
      items: [],
      filterUser: {
        custom: "",
        ogrenciProgramIds: [],
        pbsAkademisyenBirimIds: [],
        pbsIdariBirimIds: [],
        pbsDigerBirimIds: [],
      },
      degerlendirmeUser: {
        custom: "",
        ogrenciProgramIds: [],
        pbsAkademisyenBirimIds: [],
        pbsIdariBirimIds: [],
        pbsDigerBirimIds: [],
      },
      headers: [
        { text: 'Form Ekle', value: 'new', sortable: false },
        {
          text: 'Form Adı',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Başlama Tarihi', value: 'baslamaTarihi', sortable: false },
        { text: 'Bitiş Tarihi', value: 'bitisTarihi', sortable: false },
        { text: 'Değerlendirme Son Tarihi', value: 'degerlendirmeSonTarihi', sortable: false },
        { text: 'Durum', value: 'durum.name', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },

      ],
      values: [],
      personels: [],
      onayDurums: []

    }
  },
  created() {
    this.getExtBilgiler();

    this.dataBind();

  },

  methods: {
    getFormCanliItemsByFormId(id) {
      FormService.listCanliFormOgeByFormId(id).then((result) => {
        console.log("object", result.data);
        console.log("Foem ", this.editedItem);
        // this.filterItems= result.data.map(m => JSON.parse(m.json))//.filter(formItem=>(formItem.type == "select" || formItem.type == "radio" || formItem.type == "check"));
        this.filterItems = result.data.map((m) => { let x = JSON.parse(m.json); return { id: x.id, name: x.label } });
        if (this.editedItem.detayKullaniciBilgileri) {
          let detayKullaniciBilgileri = JSON.parse(this.editedItem.detayKullaniciBilgileri);
          let ogrencis = detayKullaniciBilgileri.ogrenci.map(m => { return { id: m.id, name: m.name } })
          let personels = detayKullaniciBilgileri.personel.map(m => { return { id: m.id, name: m.name } })
          this.filterItems.push(...ogrencis, ...personels)
          // console.log("dfdsfdsfsdfsdfsdfsdfsdf", this.fields);
        }

      }).catch((err) => {
        this.filterItems = []
      });
    },

    getExtBilgiler() {
      FilterUserService.OBSPBSOkunabilirAlanlar().then((result) => {
        console.log("OBSPBSOkunabilirAlanlar:", result.data);
        this.extFields = result.data;
      }).catch((err) => {

      });
    },
    getPersonel() {
      FilterUserService.getPersonelByTc(this.tc).then((result) => {
        console.log("getPersonelByTc", result.data);
        if (result.data.tc == 0) {
          this.selectedYonetici = null;
          this.$toast.warning(`${this.tc} TC li personel bulunamadı.`);

        }
        else {
          this.selectedYonetici = result.data;
        }

      }).catch((err) => {
        this.$toast.warning(err.response.data);
      });
    },
    yoneticiEkle() {
      let data = {
        formId: this.editedItem.formId,
        tc: this.selectedYonetici.tc.toString()
      }
      FormService.formYetkilendirme(data).then((result) => {
        this.listYoneticilerByFormId(data.formId);
        this.$toast.success("Başarılı bir şekilde eklenmiştir.")
      }).catch((err) => {
        this.$toast.warning(err.response.data);
      });
    },
    yetkilendirme(item) {
      this.editedItem = Object.assign({}, item);

      this.dgYoneticiForm = true;
      this.listYoneticilerByFormId(item.formId);
    },
    btnAnketRaporuClick(item) {

      router.push({ name: 'anketRapor', params: { id: item.formId } })
    },
    evDeleteYonetici(yoneticiForm) {
      if (confirm(`${yoneticiForm.ad + " " + yoneticiForm.soyad} kullanıcısının bu forma ait erişim yetkisini silmek istediğinize emin misiniz?`)) {
        FormService.deleteYoneticiFormByYoneticiFormId(yoneticiForm.yoneticiFormId).then((result) => {
          this.listYoneticilerByFormId(this.editedItem.formId);
        }).catch((err) => {

        });
      }


    },
    listYoneticilerByFormId(formId) {
      console.log("listYoneticilerByFormId:", formId);
      FormService.listYoneticilerByFormId(formId).then((result) => {
        this.lsYoneticis = result.data;
      }).catch((err) => {

      });
    },
    deleteForm(item) {
      console.log("Sil:", item);
      if (confirm('Formu silmek istediğinize emin misiniz?')) {
        FormService.delete(item).then((result) => {
          this.$toast.success("Başarılı bir şekilde silinmiştir.");
          this.dataBind();
        }).catch((err) => {

        });
      }
    },
    generateTimeOptions() {
      const times = [];
      for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 30) {
          const formattedHour = hour.toString().padStart(2, '0');
          const formattedMinute = minute.toString().padStart(2, '0');
          times.push(`${formattedHour}:${formattedMinute}`);
        }
      }
      return times;
    },

    selectedKullanicisDelete(kullanici) {
      if (confirm("Silmek istediğinize emin misiniz?")) {
        this.selectedKullanicis = this.selectedKullanicis.filter(i => i.id !== kullanici.id);

      }

    },
    btnKimlerDegerlendirecekAdd() {
      let index = this.selectedKullanicis.findIndex(m => m.id == this.selectedPersonelItem.id);
      console.log("selectedKullanicis:", this.selectedKullanicis, "index", this.selectedPersonelItem.id);
      this.selectedKullanicis.splice(index, 1, this.selectedPersonelItem);

      this.dgKullaniciKimlerDegerlendirecek = false;
      this.selectedPersonelItem = null;
    },
    btnKimleriDegerlendirecekAdd() {
      // this.selectedPersonelItem.filter = this.visibleIf;

      let index = this.selectedKullanicis.findIndex(m => m.id == this.selectedPersonelItem.id);
      console.log("index:", index);

      console.log("selectedKullanicis:", this.selectedKullanicis, "index", this.selectedPersonelItem.id);
      this.selectedKullanicis.splice(index, 1, this.selectedPersonelItem);

      this.dgKimleriDegerlendirecek = false;
      this.selectedPersonelItem = { filter: { goster: "gizle", logic: "AND", conditions: [] } };
    },
    btnKimlerDegerlendirecekDgShow(itemPersonel) {

      this.selectedPersonelItem = JSON.parse(JSON.stringify(itemPersonel));//   { ...itemPersonel };
      if (!this.selectedPersonelItem.filter) {
        this.selectedPersonelItem.filter = { ...this.visibleIfHam };
      }



      //this.dgKullaniciKimlerDegerlendirecek = true;
      this.dgKimleriDegerlendirecek = true;



    },
    btnSelectedPersonelAdd(personels) {

      let personel = personels[0];
      console.log("Personel:", personel);
      if (personel != null) {

        if (this.selectedKullanicis.some(m => m.id == personel.personelId)) {
          this.$toast.warning("Eklemeye çalıştığınız personel ekli bulunmaktadır.");
          // this.selectedPersonel = null;
          return false;
        }

        //let personelTemp={id:personel.personelId,name:personel.ad + " " + personel.soyad+" "+personel.ustBirim};
        let personelTemp = { id: personel.md5Tc, name: personel.ad + " " + personel.soyad + " " + personel.ustBirim };

        this.selectedKullanicis.push({ ...personelTemp, filter: { goster: "gizle", logic: "AND", conditions: [] }, })
        // console.log("personelTemp:",personelTemp,"selectedKullanicis:",this.selectedKullanicis);

        this.selectedPersonel = null;
      }
      else {
        this.$toast.warning("Lütfen ekleme yapmak için personel seçiniz.");
      }

    },
    // btnSelectedPersonelAdd(personel) {
    //   if (this.selectedPersonel != null) {

    //     if (this.selectedKullanicis.some(m => m.id == this.selectedPersonel.id)) {
    //       this.$toast.warning("Eklemeye çalıştığınız personel ekli bulunmaktadır.");
    //       this.selectedPersonel = null;
    //       return false;
    //     }


    //     this.selectedKullanicis.push({ ...this.selectedPersonel, filter: { goster: "gizle", logic: "AND", conditions: [] }, })
    //     this.selectedPersonel = null;
    //   }
    //   else {
    //     this.$toast.warning("Lütfen ekleme yapmak için personel seçiniz.");
    //   }

    // },
    cbPersonelChange(e) {
      console.log("cbPersonelChange", e);
    },
    // btnBirimAdd() {
    //   if (this.selectedBirimTurId == 1) {
    //     this.filterUser.pbsAkademisyenBirimIds = this.selectedBirimIds;
    //   }
    //   if (this.selectedBirimTurId == 2) {
    //     this.filterUser.pbsIdariBirimIds = this.selectedBirimIds;
    //   }
    //   if (this.selectedBirimTurId == 3) {
    //     this.filterUser.pbsDigerBirimIds = this.selectedBirimIds;
    //   }

    //   this.dgBirim = false;
    // },
    birimChange(birimtur) {
      this.selectedBirimTurId = birimtur;

      FilterUserService.PbsBirimAgaci(birimtur).then((result) => {
        //console.log("PbsBirimAgaci", result.data);
        this.items = result.data;

        if (this.selectedBirimTurId == 1) {
          this.selectedBirimIds = this.filterUser.pbsAkademisyenBirimIds;
        }
        if (this.selectedBirimTurId == 2) {
          this.selectedBirimIds = this.filterUser.pbsIdariBirimIds;
        }
        if (this.selectedBirimTurId == 3) {
          this.selectedBirimIds = this.filterUser.pbsDigerBirimIds;
        }
        this.dgBirim = true;

      }).catch((err) => {

      });
    },
    btnFormSave() {
      console.log("btnFormSave", this.$refs.frmForm.validate())

      if (!this.$refs.frmForm.validate()) {
        return false
      }

      //this.editedItem.filtrelemeJson = JSON.stringify(this.filterUser);
      this.editedItem.filtrelemeJson = JSON.stringify(this.visibleIf);

      this.editedItem.detayKullaniciBilgileri = JSON.stringify(this.selectedExtFields);
      this.editedItem.degerlendirmeJson = JSON.stringify(this.selectedKullanicis);
      console.log("filtrelemeJson:", this.editedItem.filtrelemeJson);

      console.log("Save:", this.editedItem);
      if (this.editedItem.formId == null) {
        FormService.save(this.editedItem).then((result) => {
          this.values.push(result.data);
          this.dialog = false;
          this.$toast.success("Başarılı bir şekilde kaydedilmiştir.");

        }).catch((err) => {
          console.log("Error", err.response.data);
        });
      }
      else {
        FormService.update(this.editedItem.formId, this.editedItem).then((result) => {
          Vue.set(this.values, this.editedIndex, result.data)
          //Object.assign(this.values[this.editedIndex], this.editedItem)
          this.dialog = false;
          this.$toast.success("Başarılı bir şekilde güncellenmiştir.");

        }).catch((err) => {
          console.log("Error", err.response.data);
        });
      }


    },
    editShowItem(item) {
      this.editedItem = Object.assign({}, item);
      console.log("item", item);
      this.getFormCanliItemsByFormId(item.formId);
      if (this.editedItem?.filtrelemeJson) {
        // this.filterUser = JSON.parse(this.editedItem.filtrelemeJson); 
        this.visibleIf = JSON.parse(this.editedItem.filtrelemeJson);
        if (this.editedItem?.degerlendirmeJson) {
          this.selectedKullanicis = JSON.parse(this.editedItem.degerlendirmeJson);

        }


        console.log("filterUser", this.filterUser);
      }

      if (this.editedItem?.detayKullaniciBilgileri) {
        this.selectedExtFields = JSON.parse(this.editedItem.detayKullaniciBilgileri)
      }
      else {
        this.selectedExtFields = { ogrenci: [], personel: [] }
      }




      this.editedIndex = this.values.indexOf(item);
      this.dialog = true;
    },
    btnFormUpdate(item) {

    },

    addShowItem(item) {
      this.editedItem.formId = null;
      this.selectedKullanicis = [];
      this.filterUser = {
        custom: "",
        ogrenciProgramIds: [],
        pbsAkademisyenBirimIds: [],
        pbsIdariBirimIds: [],
        pbsDigerBirimIds: [],
      };
      this.dialog = true;
      this.$refs.frmForm?.reset()
      this.$nextTick(() => {
        this.editedItem.onaylama = false;
        this.editedItem.loginGiris = false;
        this.editedItem.sadeceBirDefaBasvur = false;
      });
      this.selectedExtFields.ogrenci = [];
      this.selectedExtFields.personel = [];
      this.editedIndex = -1;
    },

    dataBind() {
      FormService.AdminFormlari().then((result) => {
        this.values = result.data;
        console.log("AdminFormlari", result.data);

        // FilterUserService.PbsPersonels().then((result) => {

        //   this.personels = result.data;
        // }).catch((err) => {

        // });


      }).catch((err) => {
        console.log("Error:", err);
      });
      DurumService.listDurums().then((result) => {
        this.durums = result.data;
      }).catch((err) => {

      });
      OnayDurumService.listAllOnayDurumsed().then((result) => {
        console.log("object  fsdfsdf", result.data);
        this.onayDurums = result.data;
      }).catch((err) => {

      });

    },
    editItem(v) {
      //router.push({ name: 'formgosterim', params: { id: v.formId } })
      router.push({ name: 'AdminFormOnGosterim', params: { id: v.formId } })
    },
    formTasarimGonder(v) {
      console.log("formTasarimGonder");
      router.push({ name: 'formtasarimi', params: { id: v.formId } })

    }
    ,
    formBasvurulariGoster(v) {
      // console.log("formTasarimGonder");
      router.push({ name: 'formdata', params: { id: v.formId } })
    },
    formKopyala(v, index) {
      // console.log("formTasarimGonder");

      if (confirm('Formu kopyalamak istediğinize emin misiniz?')) {
        FormService.formKopyala(v.formId).then((result) => {
          this.values.splice(index, 0, result.data);
          this.$toast.success("Formunuz başarılı bir şekilde kopyalanmıştır.");
        }).catch((err) => {

        });


      }

    }
  }
}
</script>